import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

import { sidebarAnimation } from '../../../animations/sidebar.animation';

@Component({
  standalone: false,
  selector: 'bt-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [sidebarAnimation]
})
export class SidebarComponent implements AfterViewInit {

  @Input() public sidebarTitle: string;
  @Input() public blockAutomaticCssSetting: boolean;

  @Output() public exit = new EventEmitter<any>();

  public sidebarContentId = 'sidebar-content-id';

  public ngAfterViewInit() {
    const el = document.getElementById(this.sidebarContentId);
    if (el && !this.blockAutomaticCssSetting) { el.firstElementChild.classList.add('flex', 'vertical', 'full-height'); }
  }

  public onClose() {
    this.exit.emit();
  }
}
